module.exports = __webpack_public_path__ + "static/media/17.6149b46f.png";